import ParcelStatusContext from "./ParcelStatusContext";

export const withParcelStatus = Component => props =>
  (
    <ParcelStatusContext.Consumer>
      {context => <Component {...props} {...context} />}
    </ParcelStatusContext.Consumer>
  );
